import React, { Component } from 'react';


// import { BrowserRouter as Router, Route, Switch } from 'react-router';

import { apiPut, apiPost, apiGet, apiDelete } from '../../Api';
import DamageTypeList from './Admin_DamageTypes_List';
import DamageTypeDetail from './Admin_DamageTypes_Detail';

export default class Admin_DamageTypes extends Component {


  constructor(props) {
    super(props);
    this.state = {
      damagetypes: [], // Load this from your backend

      creatingNewDamageType: false,
      selectedDamageTypeId: ""
    }
  }




  componentDidMount = async () => {
    this.getDamageTypes();
  }

  handleSelectDamageType = (damagetype) => {

    this.setState({
      selectedDamageType: damagetype,
      creatingNewDamageType: false,
      selectedDamageTypeId: damagetype.id,
    });

  };

  handleNewDamageType = () => {
    this.setState({
      creatingNewDamageType: true,
      selectedDamageType: {},
      selectedDamageTypeId: ""
    });
  };


  handleCancelCreate = () => {
    this.setState({
      selectedDamageType: null,
      creatingNewDamageType: false,
    });
  };

  handleUpdate = async (damagetype) => {
    const response = await apiPut("/damagetype", JSON.stringify(damagetype));
    if (response.ok) {
      this.getDamageTypes();
      this.setState({ selectedDamageTypeId: null });
    }
  };

  handleDelete = async (damagetype) => {
    // Send delete request to your backend
    const response = await apiDelete("/damagetype/" + damagetype.id);
    if (response.ok) {
      this.getDamageTypes();
      this.setState({ selectedDamageTypeId: null });
    }
  };

  handleCreate = async (damagetype) => {
    // Send delete request to your backend
    const response = await apiPost("/damagetype", JSON.stringify(damagetype));

    if (response.ok) {
      this.getDamageTypes();
      this.setState({ selectedDamageTypeId: null });
    }
    else {
      window.alert(response.text());
    }
  };

  handleSearch = (searchQuery) => {
    // Filter the damagetypes based on search query
  };

  getDamageTypes = async () => {
    const response = await apiGet("/damagetype");
    if (response.ok) {
      // console.log(response.json());
      const damagetypes = await response.json();
      this.setState({ damagetypes });
    }
  };

  // findSelectedDamageType = () => {

  //   return this.state.damagetypes.find((c) => c.id === this.state.selectedDamageTypeId);

  // }



  render() {
    const { damagetypes, creatingNewDamageType } = this.state;

    return (
      <div className="admin-settingspage">
        <DamageTypeList
          damagetypes={damagetypes}
          onSelectDamageType={this.handleSelectDamageType}
          onSearch={this.handleSearch}
          onNewDamageType={this.handleNewDamageType}
        />



        <DamageTypeDetail
          creatingNewDamageType={creatingNewDamageType}
          damagetypeId={this.state.selectedDamageTypeId}
          onUpdate={this.handleUpdate}
          onDelete={this.handleDelete}
          onCreate={this.handleCreate}
          onCancelCreate={this.handleCancelCreate}
        />

      </div>
    );
  }
}
